let defaultHeaders = {};

const wrappedFetch = function (url, params = {}) {

    let online = window.navigator.onLine;

    if (!online)
        window.location.href = "/offline.html";

    params.headers = Object.assign(
        {},
        headerDict(params.headers),
        defaultHeaders
    );
    params.credentials = 'same-origin';    

    // if (params.body
    //     && typeof params.body !== 'string'
    //     && !(params.body instanceof FormData)) {

    //         let body = new FormData();
    //         Object.entries(params.body).forEach(([k, v]) => body.append(k, v));

    //         params.body = body;
    // }

    var gotServerError = false;

    return fetch(url, params).then((response)=> {  
        if (response.redirected)
            window.location.href = response.url;
        if (!response.ok) {
            gotServerError = true;
            const err = new Error(response.statusText);
            err.response = response;           
            throw err;
        }
        return response;
    })
    .then((response) =>{
        dispatchEvent(new window.CustomEvent('fetch-end'));
        return response;
    })
    .catch((ex)=>{
        
        dispatchEvent(new window.CustomEvent('fetch-error', {detail: {
            exception: ex
          }}));
        
        // if (gotServerError){            
        //     window.location.href = "/error";
        // }
        throw ex;
    });
}

const headerDict = function (headers) {
    let dict = {};

    if (headers instanceof Headers) {
        for (let [key, value] of headers.entries()) {
            dict[key] = value;
        }
    }else{
        dict = headers;
    }

    return dict;
}

wrappedFetch.setDefaultHeaders = function (headers) {
    defaultHeaders = headerDict(headers);
}

wrappedFetch.onError = null;

wrappedFetch.throwErrors = function (response) {
    if (!response.ok) {
        const err = new Error(response.statusText);
        err.response = response;
        throw err;
    }
    return response;
}

module.exports = wrappedFetch;